import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(seleccionarHerramientaGrupoPizarra);

import { select, put } from 'redux-saga/effects';
import { seleccionarHerramienta } from '../../actions';
import { getPantalla, barraHerramientasSelectors } from '../../selectors';
import { PANTALLA_VENTANA_ID } from '../../constantes';
import { HERRAMIENTA_LAPIZ, HERRAMIENTA_MARCADOR, HERRAMIENTA_BORRADOR } from '../../pizarra/constantes';
import { activarEditor, desactivarEditor, seleccionarHerramienta as seleccionarHerramientaPizarra, seleccionarGrosorLapiz, seleccionarColorLapiz, seleccionarGrosorMarcador, seleccionarColorMarcador, seleccionarGrosorBorrador, notificarCambios } from '../../pizarra/actions';
import { getEditorActivo, getHerramienta } from '../../pizarra/selectors';
import * as CONSTANTES_PIZARRA from '../../pizarra/constantes';
import * as Util from '../../util';
import { PUNTERO_ID, ELIMINAR_DIBUJOS_ID, LAPIZ_ID, LAPIZ_GROSOR_ID, LAPIZ_COLOR_ID, MARCADOR_ID, MARCADOR_GROSOR_ID, MARCADOR_COLOR_ID, BORRADOR_ID, BORRADOR_GROSOR_ID, GRUPO_PIZARRA } from '../../herramientas/constantes';
export function seleccionarHerramientaGrupoPizarra(action) {
  var editorActivo, herramientaPizarra, pantallaId, boton, mensaje;
  return _regeneratorRuntime.wrap(function seleccionarHerramientaGrupoPizarra$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getEditorActivo);

        case 2:
          editorActivo = _context.sent;
          _context.next = 5;
          return select(getHerramienta);

        case 5:
          herramientaPizarra = _context.sent;
          _context.t0 = action.herramientaId;
          _context.next = _context.t0 === PUNTERO_ID ? 9 : _context.t0 === LAPIZ_ID ? 13 : _context.t0 === LAPIZ_GROSOR_ID ? 24 : _context.t0 === LAPIZ_COLOR_ID ? 27 : _context.t0 === MARCADOR_ID ? 30 : _context.t0 === MARCADOR_GROSOR_ID ? 41 : _context.t0 === MARCADOR_COLOR_ID ? 44 : _context.t0 === BORRADOR_ID ? 47 : _context.t0 === BORRADOR_GROSOR_ID ? 58 : _context.t0 === ELIMINAR_DIBUJOS_ID ? 61 : 77;
          break;

        case 9:
          if (!editorActivo) {
            _context.next = 12;
            break;
          }

          _context.next = 12;
          return put(desactivarEditor());

        case 12:
          return _context.abrupt('break', 77);

        case 13:
          if (!(editorActivo && herramientaPizarra === CONSTANTES_PIZARRA.HERRAMIENTA_LAPIZ)) {
            _context.next = 18;
            break;
          }

          _context.next = 16;
          return put(seleccionarHerramienta(PUNTERO_ID, GRUPO_PIZARRA));

        case 16:
          _context.next = 23;
          break;

        case 18:
          if (editorActivo) {
            _context.next = 21;
            break;
          }

          _context.next = 21;
          return put(activarEditor());

        case 21:
          _context.next = 23;
          return put(seleccionarHerramientaPizarra(HERRAMIENTA_LAPIZ));

        case 23:
          return _context.abrupt('break', 77);

        case 24:
          _context.next = 26;
          return put(seleccionarGrosorLapiz(action.valor));

        case 26:
          return _context.abrupt('break', 77);

        case 27:
          _context.next = 29;
          return put(seleccionarColorLapiz(action.valor));

        case 29:
          return _context.abrupt('break', 77);

        case 30:
          if (!(editorActivo && herramientaPizarra === CONSTANTES_PIZARRA.HERRAMIENTA_MARCADOR)) {
            _context.next = 35;
            break;
          }

          _context.next = 33;
          return put(seleccionarHerramienta(PUNTERO_ID, GRUPO_PIZARRA));

        case 33:
          _context.next = 40;
          break;

        case 35:
          if (editorActivo) {
            _context.next = 38;
            break;
          }

          _context.next = 38;
          return put(activarEditor());

        case 38:
          _context.next = 40;
          return put(seleccionarHerramientaPizarra(HERRAMIENTA_MARCADOR));

        case 40:
          return _context.abrupt('break', 77);

        case 41:
          _context.next = 43;
          return put(seleccionarGrosorMarcador(action.valor));

        case 43:
          return _context.abrupt('break', 77);

        case 44:
          _context.next = 46;
          return put(seleccionarColorMarcador(action.valor));

        case 46:
          return _context.abrupt('break', 77);

        case 47:
          if (!(editorActivo && herramientaPizarra === CONSTANTES_PIZARRA.HERRAMIENTA_BORRADOR)) {
            _context.next = 52;
            break;
          }

          _context.next = 50;
          return put(seleccionarHerramienta(PUNTERO_ID, GRUPO_PIZARRA));

        case 50:
          _context.next = 57;
          break;

        case 52:
          if (editorActivo) {
            _context.next = 55;
            break;
          }

          _context.next = 55;
          return put(activarEditor());

        case 55:
          _context.next = 57;
          return put(seleccionarHerramientaPizarra(HERRAMIENTA_BORRADOR));

        case 57:
          return _context.abrupt('break', 77);

        case 58:
          _context.next = 60;
          return put(seleccionarGrosorBorrador(action.valor));

        case 60:
          return _context.abrupt('break', 77);

        case 61:
          _context.next = 63;
          return select(getPantalla);

        case 63:
          pantallaId = _context.sent;
          _context.next = 66;
          return select(barraHerramientasSelectors.getBoton, ELIMINAR_DIBUJOS_ID);

        case 66:
          boton = _context.sent;
          mensaje = pantallaId === PANTALLA_VENTANA_ID ? boton.mensajeVentana || boton.mensaje : boton.mensaje;

          if (!Util.confirm(mensaje)) {
            _context.next = 76;
            break;
          }

          if (!editorActivo) {
            _context.next = 72;
            break;
          }

          _context.next = 72;
          return put(desactivarEditor());

        case 72:
          _context.next = 74;
          return put(notificarCambios(null));

        case 74:
          _context.next = 76;
          return put(seleccionarHerramienta(PUNTERO_ID, GRUPO_PIZARRA));

        case 76:
          return _context.abrupt('break', 77);

        case 77:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}